import { IGameState } from "State/Game/IGameState";

export function incrementCardSequence(state: IGameState): IGameState {
    state = {
        ...state,
        levelState: {
            ...state.levelState,
            cardMatchSequenceIndex: state.levelState.cardMatchSequenceIndex + 1,
        },
    };
    return updateCardSequence(state);
}

export function updateCardSequence(state: IGameState): IGameState {
    return {
        ...state,
        levelState: {
            ...state.levelState,
            cardMatchSequenceIndex:
                state.levelState.cardMatchSequence.length > 0
                    ? state.levelState.cardMatchSequenceIndex % state.levelState.cardMatchSequence.length
                    : 0,
        },
    };
}